import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  Filter,
  BooleanField,
  ImageField,
} from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import ListActions from '../common/ListActions'

const MerchantList = (props) => (
  <List {...props} filters={<Filters />} actions={<ListActions {...props} />}>
    <Datagrid rowClick='edit'>
      <TextField source='id' />
      <TextField source='short_reference' />
      <TextField source='name' />
      <TextField source='api_name' />
      <ReferenceField source='organization_id' reference='organization'>
        <TextField source='name' />
      </ReferenceField>
      <BooleanField source='active' />
      <ImageField source='logo_url' />
      <DateField source='created_at' />
      <DateField source='updated_at' />
    </Datagrid>
  </List>
)

const Filters = (props) => (
  <Filter {...props}>
    <AutocompleteReferenceInput
      label='Search by Organization'
      source='organization_id'
      reference='organization'
      optionText='name'
      allowEmpty
      alwaysOn
    />
    <AutocompleteReferenceInput
      label='Search by name'
      source='id'
      reference='merchant'
      optionText='name'
      allowEmpty
      alwaysOn
    />
  </Filter>
)

export default MerchantList
